module.exports = __webpack_public_path__ + "img/change.org.png";